import React from "react";
import FormContainer from "./FormContainer";

const CreateEvent = () => {
  return (
    <div className="create-event-main">
      <FormContainer />
    </div>
  );
};

export default CreateEvent;
